export const dataNodeEndpoints = {
  ping: 'ping/0x0',
  checkout: 'checkout',
};
